import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGiroResponse, IGiroRequest } from '../interfaces/giro.interface';

@Injectable({
  providedIn: 'root'
})
export class GiroService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}Giros/cmspa_girosList`;
  private readonly API_URL_SAVE = `${environment.apiNewBackBaseUrl}Giros/cmspa_girosAdd`;
  private readonly API_URL_DETAIL = `${environment.apiNewBackBaseUrl}Giros/cmspa_girosDetail`;
  private readonly API_URL_UPDATE = `${environment.apiNewBackBaseUrl}Giros/cmspa_girosUpd`;
  private readonly API_URL_DELETE = `${environment.apiNewBackBaseUrl}Giros/cmspa_girosDelete`;

  constructor(private http: HttpClient) { }

  getGiros(): Observable<IGiroResponse> {
    const payload: IGiroRequest = {
      que: 4,
      tope: "999",
      cmd: "",
      clave_giro: "",
      tipo_dedicacion: "",
      descripcion: "",
      score: 0,
      politica: "",
      sueldoMinimo: 0,
      mensajeScoring: ""
    };
    return this.http.post<IGiroResponse>(this.API_URL, payload);
  }

  getGiroDetail(clave_giro: string): Observable<IGiroResponse> {
    const payload: IGiroRequest = {
      que: 5,
      tope: "",
      cmd: "",
      clave_giro: clave_giro,
      tipo_dedicacion: "",
      descripcion: "",
      score: 0,
      politica: "",
      sueldoMinimo: 0,
      mensajeScoring: ""
    };
    return this.http.post<IGiroResponse>(this.API_URL_DETAIL, payload);
  }

  saveGiro(giro: IGiroRequest): Observable<{ success: boolean; data: boolean }> {
    const payload: IGiroRequest = {
      que: 1,
      tope: "",
      cmd: "",
      clave_giro: giro.clave_giro,
      tipo_dedicacion: giro.tipo_dedicacion,
      descripcion: giro.descripcion,
      score: 0,
      politica: "",
      sueldoMinimo: 0,
      mensajeScoring: ""
    };
    return this.http.post<{ success: boolean; data: boolean }>(this.API_URL_SAVE, payload);
  }

  updateGiro(giro: IGiroRequest): Observable<{ success: boolean; data: boolean }> {
    const payload: IGiroRequest = {
      que: 2,
      tope: "",
      cmd: "",
      clave_giro: giro.clave_giro,
      tipo_dedicacion: giro.tipo_dedicacion,
      descripcion: giro.descripcion,
      score: 0,
      politica: "",
      sueldoMinimo: 0,
      mensajeScoring: ""
    };
    return this.http.post<{ success: boolean; data: boolean }>(this.API_URL_UPDATE, payload);
  }

  deleteGiro(clave_giro: string): Observable<{ success: boolean; data: boolean }> {
    const payload: IGiroRequest = {
      que: 3,
      tope: "",
      cmd: "",
      clave_giro: clave_giro,
      tipo_dedicacion: "",
      descripcion: "",
      score: 0,
      politica: "",
      sueldoMinimo: 0,
      mensajeScoring: ""
    };
    return this.http.post<{ success: boolean; data: boolean }>(this.API_URL_DELETE, payload);
  }
} 